import { object, string } from 'yup'

const schema = object().shape({
    email: string().required('*Email is required').email('*Please enter a correct email format'),
    password: string()
        .required('*Password is required')
        .matches(
            /^((?=.*\d)(?=.*[A-Z])(?=.*\W).{7,})$/,
            '*Password must have at least 1 lowercase letter, 1 uppercase letter, 1 symbol and 1 number'
        )
        .min(8, '*Password must be at least 8 characters'),
})

export default schema
